import { Auth } from 'core/auth';
import * as actions from 'core/auth/actions';
import React from 'react';
import { connect } from 'react-redux';
import { firebase } from 'utils';

interface StateProps {
  auth: Auth;
}

interface DispatchPropsInterface {
  signInError: (error: string) => void;
  signingIn: () => void;
  signIn: (idToken: string, user: firebase.User) => void;
}

type Props = DispatchPropsInterface & StateProps;

interface SignInInterface {
  onSignIn: () => void;
}

const SignIn = ({ onSignIn }: SignInInterface) => {
  return (
    <button className='ui google plus button' onClick={onSignIn}>
      <i className='google icon' />
      Sign in
    </button>
  );
};

const SigningIn = () => {
  return (
    <button className='ui google plus button'>
      <i className='fa fa-circle-o-notch fa-spin' />
    </button>
  );
};

class GoogleAuthComponent extends React.Component<Props> {
  onSignIn = async () => {
    this.props.signingIn();
    try {
      const provider = new firebase.auth.GoogleAuthProvider();
      await firebase.auth().signInWithPopup(provider);
    } catch (e) {
      this.props.signInError('Ocorreu um erro ao realizar login');
    }
  };

  render() {
    const { isSignedIn, isSigningIn } = this.props.auth;
    if (isSignedIn) {
      return null;
    } else if (isSigningIn) {
      return <SigningIn />;
    } else {
      return <SignIn onSignIn={this.onSignIn} />;
    }
  }
}

function mapStateToProps({ auth }: { auth: Auth }): StateProps {
  return {
    auth,
  };
}

export const GoogleAuth = connect(
  mapStateToProps,
  actions,
)(GoogleAuthComponent);
